module.exports = __webpack_public_path__ + "static/media/allianz.dbc15d9b.svg";